import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  Renderer2
} from '@angular/core';
import {
  BreakpointClassesCtor,
  CanGenerateBreakpointClasses,
  InputValue,
  mixinBreakpointClassesGenerator
} from 'ng-labs/core';

class FlexGridBase {
  constructor(public renderer: Renderer2) {}
}

const FlexGridMixinBase: BreakpointClassesCtor &
  typeof FlexGridBase = mixinBreakpointClassesGenerator(FlexGridBase);

/**
 * `<labs-flex-grid>` displays a grid made up of flexbox CSS properties.
 */
@Component({
  selector: 'labs-flex-grid',
  template: '<ng-content select="labs-flex-grid-column"></ng-content>',
  styleUrls: ['./flex-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FlexGridComponent extends FlexGridMixinBase
  implements CanGenerateBreakpointClasses {
  @Input()
  set align(value: InputValue) {
    const element = this.elementRef.nativeElement;
    const prefix = 'align';

    if (value !== this._align) {
      this.removeBreakpointClasses(element, prefix, this._align);
      this.addBreakpointClasses(element, prefix, value);

      this._align = value;
    }
  }

  private _align: InputValue;

  @Input()
  set justify(value: InputValue) {
    const element = this.elementRef.nativeElement;
    const prefix = 'justify';

    if (value !== this._justify) {
      this.removeBreakpointClasses(element, prefix, this._justify);
      this.addBreakpointClasses(element, prefix, value);

      this._justify = value;
    }
  }

  private _justify: InputValue;

  constructor(private elementRef: ElementRef, public renderer: Renderer2) {
    super(renderer);
  }
}
